module.exports = __webpack_public_path__ + "static/media/gloria-icon.d6ab0cba.png";